// Vendors API + shared formatting
import { SMIIFY_API } from '../config/api';

export const VENDOR_API = `${SMIIFY_API}/vendors`;
export const INVENTORY_API = `${SMIIFY_API}/inventory`;

/** fetch with login + branch headers; throws Error(message) on failure */
export const vendorFetch = async (url, { method = 'GET', body, storeId } = {}) => {
    const sid = storeId || localStorage.getItem('smiify_active_store_id') || '';
    // full addresses (another API, e.g. inventory) are used as they are; '/bills', '/summary', '?q=' go under /vendors
    const full = /^https?:\/\//.test(url) || url.startsWith(SMIIFY_API);
    const res = await fetch(full ? url : `${VENDOR_API}${url}`, {
        method,
        headers: {
            Authorization: `Bearer ${localStorage.getItem('smiify_token')}`,
            ...(sid ? { 'x-store-id': sid } : {}),
            ...(body ? { 'Content-Type': 'application/json' } : {}),
        },
        body: body ? JSON.stringify(body) : undefined,
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok || json.success === false) throw new Error(json.message || `Request failed (${res.status}).`);
    return json;
};
export const errText = (e) => (e?.message === 'Failed to fetch' ? 'Cannot reach the server.' : e?.message || 'Something went wrong.');

export const inr = (v) => `₹${Math.round(Number(v) || 0).toLocaleString('en-IN')}`;
export const inr2 = (v) => `₹${(Number(v) || 0).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '—');
export const ymd = (d = new Date()) => { const x = new Date(d); return `${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, '0')}-${String(x.getDate()).padStart(2, '0')}`; };
export const addDaysYmd = (dateYmd, days) => { const [y, m, d] = dateYmd.split('-').map(Number); return ymd(new Date(y, m - 1, d + Number(days || 0))); };
export const r2 = (n) => Math.round((Number(n) || 0) * 100) / 100;

export const MODES = [
    { value: 'CASH', label: 'Cash' }, { value: 'UPI', label: 'UPI' }, { value: 'BANK', label: 'Bank transfer' },
    { value: 'CARD', label: 'Card' }, { value: 'CHEQUE', label: 'Cheque' },
];
export const modeLabel = (m) => MODES.find((x) => x.value === m)?.label || m || '—';
export const CLEARS_AT_ONCE = ['CASH', 'UPI', 'CARD'];
export const GST_RATES = [0, 5, 12, 18, 28];

export const STATUS = {
    UNPAID: { label: 'Unpaid', tone: 'red' },
    PARTIAL: { label: 'Part paid', tone: 'amber' },
    PAID: { label: 'Paid', tone: 'green' },
    CANCELLED: { label: 'Cancelled', tone: 'grey' },
};
/** + we owe, - vendor owes us */
export const balanceText = (b) => (b > 0.009 ? { text: `You owe ${inr(b)}`, tone: 'red' } : b < -0.009 ? { text: `Credit ${inr(-b)}`, tone: 'green' } : { text: 'Settled', tone: 'grey' });
